import { CollectionApiFormat } from '@/src/lib/http/jsonapi/deserializer';
import { Capability } from '@/src/lib/capability/config';
import { TenantConfig } from '@/src/lib/store/tenants-config';

export enum StoreTenant {
  NL = 'NL',
  AU = 'AU',
  PL = 'PL',
  HU = 'HU',
  BE = 'BE',
  SE = 'SE',
  DE = 'DE',
  MX = 'MX',
  AT = 'AT',
  FR = 'FR',
  CZ = 'CZ',
}

export type StoreCodeNameAttribute = {
  code: string;
  name: string;
};

export type StoreIso2CodeNameAttribute = {
  iso2Code: string;
  name: Locale | string;
};

export type StoreCodeLocaleNameAttribute = {
  code: string;
  name: Locale;
};

export type StoreCountryAttributes = {
  iso2Code: string;
  iso3Code: string;
  name: string;
  postalCodeMandatory: boolean;
  postalCodeRegex: string;
  regions: Array<StoreIso2CodeNameAttribute>;
};

export type StoreRestAttributes = {
  timeZone: string;
  defaultCurrency: string;
  currencies: Array<StoreCodeNameAttribute>;
  locales: Array<StoreCodeLocaleNameAttribute>;
  countries: Array<StoreCountryAttributes>;
};

export type StoreResponse = CollectionApiFormat<StoreRestAttributes>;

export type Locale = `${string}_${string}`;

export class StoreAttributes implements StoreRestAttributes {
  public timeZone = '';
  public defaultCurrency = '';
  public currencies: Array<StoreCodeNameAttribute> = [];
  public locales: Array<StoreCodeLocaleNameAttribute> = [];
  public countries: Array<StoreCountryAttributes> = [];
  public storeFeatures?: Array<{ type: string; id: string; features: Array<Capability> }>;
}

export type DeserializedStore = {
  id: StoreTenant;
  type: 'stores';
} & StoreAttributes &
  Record<string, unknown>;

export type DeserializedStoreWithTenantConfig = DeserializedStore & {
  tenantConfig: TenantConfig;
};
